(ns iris.styles.thread-alerts
  (:require
;;    [herb.core :refer [<class <id]]
   ;; [garden.units :refer [px]]
   [shadow.css :refer [css]]
   ))


(def $alert
  (css {:margin-bottom "10px"
        :background "rgb(245, 247, 215)"
        :color "rgb(31, 69, 87)"
        :border-color "rgb(211, 241, 188)"
        :padding "12px 25px 12px 12px !important"
        :position "relative"
        :border "1px solid transparent"
        :border-radius "0.25rem"}
       ["&>svg" {:display "inline"}]))

(def $alert-list
  (css {:position "absolute"
        :top "50px"
        :right "0px"
        :width "385px"
        :z-index "1100"
        :background "navy"
        :padding "10px"
        :border-radius "0px 0px 5px 5px"
        :border-style "solid"
        :border-width "0px 1px 1px 1px"
        :border-color "black"
        :overflow-y "auto"
        :max-height "calc(100vh - 25px)"}))

(def $alert-list-empty
  [$alert-list
   (css {:text-align "center"})])

(def $thread-info
  (css {:padding "0 0 0 20px"
        :font-size "small"}))

(def $close-btn
  (css {:right "-5px !important"
        :position "absolute"
        :top "0"
        :z-index "2"
        :padding "0.75rem 1.25rem"
        :color "inherit"
        :float "right"
        :font-size "1.75rem"
        :font-weight "700"
        :line-height "1"
        :text-shadow "0 1px 0 #fff"
        :opacity ".5"
        :background-color "transparent"
        :border "0"}))


(def $show-all-btn
  (css {:display "block"
        :width "100%"
        :border "0"
        :border-radius "3px"
        :background "rgba(0,0,0,0.25)"
        :text-align "center"
        :padding "3px"}))


(def $show-less-btn
  [$show-all-btn
   (css {:display "inline-block"
         :width "49%"
         :float "left"})])


(def $del-all-btn
  [$show-all-btn
   (css {:background "rgba(255,0,0, 0.8)"
         :display "inline-block"
         :width "49%"
         :float "right"})])


(def $alert-list-btn
  ["btn"
   (css {:position "relative"
         :float "right"
         :margin-top "8px"
         :margin-right "5px"
         :background-color "rgb(0, 0, 128)"
         :border-color "#333"
         :color "white !important"}
        [:hover {:filter "brightness(120%)"}])])

(def $alert-list-btn-badge
  ["badge"
   (css {:position "absolute !important"
         :font-size "11px !important"
         :background "#e40303 !important"
         :color "white !important"
         :right "-8px !important"
         :top "-4px !important"})])

(def $alert-title-link
  (css {:cursor "pointer"
        :font-weight "bold"
        :text-decoration "underline"
        :color "#03c !important"
        :margin "-2px 5px"
        :white-space "nowrap"
        :overflow "hidden"
        :text-overflow "ellipsis"
        :width "200px"
        :display "inline-block"}))

(def $alert-time-ago
  (css
   {:float "right"}))

(def $alert-follow-btn
  ["btn"
   (css
    :bg-gray-200
    [:hover :bg-gray-300])])

;; (defn alert []
;;   {
;;    ;; :margin-bottom "10px"
;;    ;; :background "#F5F7D7"
;;    ;; :color "#1f4557"
;;    ;; :border-color "#d3f1bc"
;;    ;; :padding "12px !important"
;;    ;; :padding-right "25px !important"

;;     :margin-bottom "10px"
;;     :background "rgb(245, 247, 215)"
;;     :color "rgb(31, 69, 87)"
;;     :border-color "rgb(211, 241, 188)"
;;     :padding "12px 25px 12px 12px !important"


;;    :position "relative"
;;    ;; :padding"0.75rem 1.25rem"
;;    ;; :margin-bottom "1rem"
;;    :border "1px solid transparent"
;;    :border-radius "0.25rem"

;;     ;; @media (min-width: 340px){
;;     ;;   min-width: 340px;
;;     ;; }
;;    })


;; (defn alert-list []
;;   {:position "absolute"
;;    :top "50px"
;;    :right "0px"
;;    :width "385px"
;;    :z-index "1100"
;; ;;   :background rgba(${props => props.bg}, 1);
;;    :background "navy"
;;    :padding "10px"
;;    :border-radius "0px 0px 5px 5px"
;;    :border-style "solid"
;;    :border-width "0px 1px 1px 1px"
;;    :border-color "black"
;; ;;   @media (max-width: 640px) {
;; ;;     width: 100%;
;; ;;     right: 0px;
;; ;;   }
;;    })


;; (defn alert-list-empty []
;;   ^{:extend alert-list}
;;   {:text-align "center"})


;; (defn thread-info []
;;   {:padding "0 0 0 20px"
;;    :font-size "small"})





;; (defn close-btn []
;;   {:right "-5px !important"
;;    :position "absolute"
;;    :top "0"
;;    ;;  :right "0"
;;    :z-index "2"
;;    :padding "0.75rem 1.25rem"
;;    :color "inherit"

;;    :float "right"
;;    :font-size "1.75rem"
;;    :font-weight "700"
;;    :line-height "1"
;;    ;;  :color "#000"
;;    :text-shadow "0 1px 0 #fff"
;;    :opacity ".5"
;;    :background-color "transparent"
;;    :border "0"})


;; (defn show-all-btn []
;;   {:display "block"
;;    :width "100%"
;;    :border "0"
;;    :border-radius "3px"
;;    :background "rgba(0,0,0,0.25)"
;;    :text-align "center"
;;    :padding "3px"})


;; (defn show-less-btn []
;;   ^{:extend show-all-btn}
;;   {:display "inline-block"
;;    :width "49%"
;;    :float "left"})


;; (defn del-all-btn []
;;   ^{:extend show-less-btn}
;;   {:background "rgba(255,0,0, 0.8)"
;;    :float "right"})


;; (defn alert-list-btn []
;; {:position "relative"
;;  :float "right"
;;  :margin-top "8px"
;;  :margin-right "5px"
;;  :background-color "rgb(0, 0, 128)"
;;  :border-color "#333"
;;  :color "white !important"
;; ;;   &:hover, &:active, &:visited{
;; ;;     color: white !important;
;; ;;   }
;;  })


;; (defn alert-list-btn-badge []
;;   {:position "absolute !important"
;;    :font-size "11px !important"
;;    :background "#e40303 !important"
;;    :color "white !important"
;;    :right "-8px !important"
;;    :top "-4px !important"})

;; export const AlertListBtn = styled.button `
;;   position: relative;
;;   float: right;
;;   // margin-top: 8px;
;;   margin-right: 8px;
;;   background-color: rgba(${props => props.bg}, 1);
;;   border-color: #333;
;;   color: white !important;
;;   &:hover, &:active, &:visited{
;;     color: white !important;
;;   }
;; `
;; export const AlertListBtnBadge = styled.span `
;;   position: absolute !important;
;;   font-size: 11px !important;
;;   background: #e40303 !important;
;;   color: white !important;
;;   right: -8px !important;
;;   top: -4px !important;
;; `


;; (defn alert-title-link []
;;   {:cursor "pointer"
;;    :font-weight "bold"
;;    :text-decoration "underline"
;;    :color "#03c !important"
;;    :margin "-2px 5px"
;;    :white-space "nowrap"
;;    :overflow "hidden"
;;    :text-overflow "ellipsis"
;;    :width "200px"
;;    :display "inline-block"})

;; (defn alert-time-ago []
;;   {:float "right"})